import styled from '@emotion/styled';
import { colorPalettes, Flex, SPACES } from '@linearb/linui-common';

const StyledLoginModal = styled(Flex)`
  background: ${({ theme }) =>
    colorPalettes[theme.palette.mode].background.loginModal};
  border: 1px solid
    ${({ theme }) => colorPalettes[theme.palette.mode].stroke.loginModal};
  border-radius: 4px;
  padding-top: ${SPACES['large']};
  flex-direction: column;
  justify-content: space-between;
`;

export const StyledLoginModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  margin-bottom: ${SPACES['x-x-large']};

  ${Flex} {
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
`;

export default StyledLoginModal;
